<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		width="600px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon dark fab color="secondary" v-bind="attrs" v-on="on" class="mt-4"> </v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs" min-height="60vh">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">チェックシートの選択</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-sheet elevation="0" class="pa-2" height="auto">
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						:headers="headers"
						:items="checkSheets"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr>
								<td @click="openOrderIndividualInfoPage(item.id)">
									{{ item.name }}
								</td>
							</tr>
						</template>
					</v-data-table>
				</div>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		checkSheets: {
			type: Array,
			required: true,
		},
	},

	data() {
		return {
			headers: [{ text: "チェックシート名", value: "name", width: "280px" }],
			check_sheets: [],
		}
	},
	methods: {
		openOrderIndividualInfoPage(check_sheet_id) {
			this.$emit("open-page", check_sheet_id)
		},
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>

<style lang="scss" scoped></style>
